(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moru-product-card"] && !Shopify.designMode) return;
  try {
    class MoruSwatches extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.moru-product-card');
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.moru-product-card__swatch');
        if (!button) return;
        event.preventDefault();

        this.querySelectorAll('.moru-product-card__swatch').forEach((swatch) => {
          swatch.classList.toggle('is-active', swatch === button);
        });

        if (!this.card) return;

        const image = this.card.querySelector('.moru-product-card__image');
        if (image && button.dataset.swatchImage) {
          image.removeAttribute('srcset');
          image.src = button.dataset.swatchImage;
        }

        const link = this.card.querySelector('[data-card-link]');
        if (link && button.dataset.swatchUrl) {
          link.href = button.dataset.swatchUrl;
        }
      });
    }
  }

  if (!customElements.get('moru-swatches')) {
    customElements.define('moru-swatches', MoruSwatches);
  }
  } catch(e) { console.error(e); }
})();

})();
